import { FaInstagram, FaTwitter, FaWhatsapp } from 'react-icons/fa';
import styled from 'styled-components';

export const FooterContainer = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #0044cc;
  color: white;
  margin-top: 2em;
  padding: 20px;
  border-radius: 15px 15px 0 0;
  text-align: center;
  padding-top: 2em;

  @media (max-width: 768px) {
    padding: 10px;
    border-radius: 15px 15px 0 0;
    padding-top: 2em;
  }
`;

export const Logo = styled.img`
  max-width: 150px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    max-width: 100px;
  }
`;

export const Info = styled.p`
  font-size: 1em;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    font-size: 0.9em;
  }
`;

export const SocialLinks = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;

  padding: 0 2em;
  gap: 15px;
  width: 100%;
`;

export const SocialLink = styled.a`
  color: white;
  font-size: 1.5em;

  &:hover {
    color: #ffcc00;
  }

  @media (max-width: 768px) {
    font-size: 1.2em;
  }
`;

export const WhatsAppIcon = styled(FaWhatsapp)`
  font-size: inherit;
`;

export const InstagramIcon = styled(FaInstagram)`
  font-size: inherit;
`;

export const TwitterIcon = styled(FaTwitter)`
  font-size: inherit;
`;

export const NavLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
`;

export const NavLink = styled.a`
  color: white;
  font-size: 1em;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  @media (max-width: 768px) {
    font-size: 0.9em;
  }
`;
